module.exports = __webpack_public_path__ + "static/img/product3s-3.fc3197b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/product3s-3.jpg
// module id = pllm
// module chunks = 0